(function() { window.GUID_7f7dddd0_ca35_4b3c_8867_ff05deda5dfd = { getGuid: function() { return "7f7dddd0-ca35-4b3c-8867-ff05deda5dfd"; } }; })();


//# sourceMappingURL=ifixed-header.js.map
